import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyAmDiIN_p1btW-4j00HWN2_dan3GNURKd4',
  authDomain: 'odontofacil-9078e.firebaseapp.com',
  databaseURL: 'https://odontofacil-9078e-default-rtdb.firebaseio.com',
  projectId: 'odontofacil-9078e',
  storageBucket: 'odontofacil-9078e.appspot.com',
  messagingSenderId: '421531020798',
  appId: '1:421531020798:web:528f8674ac3dcec1c124af',
  measurementId: 'G-KL7N5HFBGK'
};
// Get a Firestore instance
const app = firebase
  .initializeApp(firebaseConfig);
firebase.analytics();

const firestore = app.firestore();

firestore.enablePersistence();

export const db = firestore;
export const rdb = app.database();

export const storage = firebase.storage(app);

export const auth = app.auth();
